import { client } from '..';
import { Mission, MissionsResponse } from '../models/missionModel';

export const getMissions = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | string[] | number | undefined)[];
  pageParam: string | undefined;
}): Promise<MissionsResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, __, limit, missionTypes] = queryKey;

  const missionsTypesParams = new URLSearchParams({ missionTypes: missionTypes?.toString() ?? '' }).toString();

  const url = `/missions/scrolling?enabled=true&limit=${limit}&n=${pageParam}&${missionsTypesParams}`;

  const response = await client.get(url);

  return response.data;
};

export const getMissionDetail = async ({ missionId }: { missionId: string }): Promise<Mission> => {
  const url = `/missions/${missionId}`;

  const response = await client.get(url);

  return response.data;
};
